import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Employee.css';

const Employee = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: window.innerWidth <= 768 ? 0.1 : 0.3,
        rootMargin: '50px'
      }
    );

    const section = document.getElementById('employee');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section id="employee" className="employee section">
      <div className="container">
        <div className={`employee-content ${isVisible ? 'visible' : ''}`}>
          <h2 className="employee-title fade-in-up">
            {t('employee.title')}
          </h2>

          <div className="employee-grid">
            {/* The Architect - Formal/Professional */}
            <div className="employee-card fade-in-up architect-card">
              <div className="employee-photo">
                <img src="/sluzbowe.png" alt="Antoni Cieślak - Professional" className="employee-image" />
              </div>

              <div className="employee-info">
                <h3 className="employee-name">{t('employee.architectName')}</h3>
                <p className="employee-role">{t('employee.architectRole')}</p>
                <p className="employee-description">
                  {t('employee.architectDescription')}
                </p>

                <div className="employee-skills">
                  {t('employee.architectSkills', { returnObjects: true }).map((skill, index) => (
                    <span key={index} className="skill-tag">{skill}</span>
                  ))}
                </div>

              </div>
            </div>

            {/* The Core - Humorous/Multi-role */}
            <div className="employee-card fade-in-up core-card">
              <div className="employee-photo">
                <img src="/profilowe.jpg" alt="Antoni Cieślak - Development Squad" className="employee-image" />
              </div>

              <div className="employee-info">
                <h3 className="employee-name">{t('employee.coreName')}</h3>
                <p className="employee-role">{t('employee.coreRole')}</p>
                <p className="employee-description">
                  {t('employee.coreDescription')}
                </p>

                <div className="employee-skills">
                  {t('employee.coreSkills', { returnObjects: true }).map((skill, index) => (
                    <span key={index} className="skill-tag">{skill}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* CV Section */}
          <div className="cv-section fade-in-up" style={{ marginTop: 'var(--spacing-xxl)', textAlign: 'center' }}>
            <h3 style={{ fontSize: '1.8rem', marginBottom: 'var(--spacing-lg)', color: 'var(--neon-cyan)', textShadow: '0 0 10px var(--neon-cyan)' }}>
              {t('employee.cvs')}
            </h3>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 'var(--spacing-lg)', flexWrap: 'wrap' }}>
              <a href="/AntoniCieslakVFXTech.pdf" target="_blank" rel="noopener noreferrer" className="btn">
                {t('employee.vfxCv')}
              </a>
              <a href="/AntoniCieslakWebAI.pdf" target="_blank" rel="noopener noreferrer" className="btn">
                {t('employee.webCv')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Employee;